import { useEffect } from 'react';
import { CatRadioField } from '@blocks-react/components/RadioField';
import { CatFieldset } from '@blocks-react/components/Fieldset';
import { ORDER_TYPE_RADIO_NAME } from '../../constants/constants';
import { useFormContext } from 'react-hook-form';
import { useTranslations } from 'next-intl';
import { getDefaultValue } from '../../utils';
import cx from 'classnames';
import styles from '../select-customer-form/style.module.scss';

export const OrderType = ({
  orderTypeInfo,
  radioFieldClassname = null,
  radioFieldClassnameStock = null,
  disabled = false
}) => {
  const t = useTranslations();

  const [standardOrder, stockOrder] = orderTypeInfo;
  const orderTypeLabel = t('CAT_SHOPPING_PREFERENCES_ORDER_TYPE');
  const stockLabel = t('CAT_MA_STOCK');
  const standardLabel = t('CAT_MA_STANDARD');

  const { setValue, watch } = useFormContext();

  useEffect(() => {
    const defaultObj = getDefaultValue([standardOrder, stockOrder]);
    if (!defaultObj) {
      // In case there's no default, set it to be 'Standard'
      setValue(ORDER_TYPE_RADIO_NAME, standardOrder?.value);
    } else if (defaultObj?.code) {
      // If we do have default, set it
      setValue(ORDER_TYPE_RADIO_NAME, defaultObj?.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderTypeInfo]);

  const currentOrderType = watch(ORDER_TYPE_RADIO_NAME);


  return (
    // We decided not to use the component AssociatedDealerOrderType because
    // the new response comes differently and it's not compatible with the
    // old component anymore.

    <CatFieldset required>
      <span className="cat-u-theme-typography-label-lg">{orderTypeLabel}</span>
      <span
        className={cx(
          styles['required-field'],
          'cat-u-theme-typography-footnote'
        )}
      >
        {' (required)'}
      </span>

      <CatRadioField
        name={ORDER_TYPE_RADIO_NAME}
        data-testid={'order-type-stock'}
        onBlRadioChange={(e) => setValue(ORDER_TYPE_RADIO_NAME, e.detail.value)}
        id={stockOrder?.code}
        value={stockOrder?.value}
        checked={currentOrderType === stockOrder?.value}
        {...(radioFieldClassnameStock && {
          className: radioFieldClassnameStock
        })}
        disabled={disabled}
        label={stockOrder?.label || stockLabel}
      />
      <CatRadioField
        name={ORDER_TYPE_RADIO_NAME}
        data-testid={'order-type-standard'}
        onBlRadioChange={(e) => setValue(ORDER_TYPE_RADIO_NAME, e.detail.value)}
        id={standardOrder?.code}
        value={standardOrder?.value}
        checked={currentOrderType === standardOrder?.value}
        {...(radioFieldClassname && { className: radioFieldClassname })}
        disabled={disabled}
        label={standardOrder?.label ||standardLabel}
      />
    </CatFieldset>
  );
};
